<template>
  <div class="bolsawhitewrapper row align-center" id="bolsadetalhe">
    <div class="small-11 medium-10 large-9 columns">
      <div class="extensao_banner">
        <BreadCrumb 
          :breadcrumb="breadcrumb"
          class="bcp" />
        <LogoBox 
          v-if="bolsa != null"
          :name="bolsa.name"
          :image="bolsaImage"/>  
        <h1 class="bolsadetalhetitulo">{{ bolsa?.Titulo }}</h1>
      </div>
      <div class="row align-center bolsawrapper" v-if="bolsa != null">
        <div class="small-12 medium-12 large-12 columns">
          <div class="bolsadescricao" v-html="bolsa.Introducao"></div>
          <BolsaDetalheSeccoes :bolsa="bolsa"/>  
          <a class="protocolo" target="_blank" :href="bolsa.Protocolo" v-if="bolsa.Protocolo.length > 0">
            <span class="download_icon_large">
              <i class="ms-Icon ms-Icon--Download"></i>
            </span>{{ $t("UMA_LANG_SASUMA_BOLSAS_DETALHE_DESCARREGARPROTOCOLO") }}
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { useRoute, onBeforeRouteLeave } from 'vue-router';
import { ref, computed } from "vue";
import { i18n } from "@/main.js";
import BreadCrumb from "@/components/BreadCrumb.vue";
import axios from "@/axios";
import LogoBox from "@/components/LogoBox.vue";
import BolsaDetalheSeccoes from "@/components/BolsaDetalheSeccoes.vue";

import fundo from "@/assets/images/sas_logo_fundo.png";
import dges from "@/assets/images/logo_bolsa_dges.png";
import afa from "@/assets/images/sas_logo_afa.png";
import santander from "@/assets/images/logo_bolsa_santander.png";
import blandy from "@/assets/images/sas_logo_blandy.png";

export default {
  components: {
    BreadCrumb,
    LogoBox,
    BolsaDetalheSeccoes
  },
  setup() {

    const { t } = i18n.global;
    const lang = i18n.global.locale;
    const lg = lang == "en" ? "/en" : "";

    const breadcrumb = ref([
      { ID: 1, text: 'Homepage', href: `https://www.uma.pt${lg}` },
      { ID: 2, text: t("breadcrumb.sobre"), href: `https://www.uma.pt${lg}/sobre` },
      { ID: 3, text: t("breadcrumb.apoio"), href: `https://www.uma.pt${lg}/sobre/servico-apoio-estudantes` },
      { ID: 4, text: t("breadcrumb.sas"), route: { to: "/" } },
      { ID: 5, text: t("breadcrumb.bolsas"), route: { to: "/bolsasdeestudo" } },
    ]);

    const bolsaslogo = {
      'bolsa-dges': dges,
      'bolsa-santander': santander,
      'bolsa-afa': afa,
      'bolsa-blandy': blandy,
      'fundo-de-apoio-de-emergencia': fundo
    }

    const bolsaImage = computed(() => {
      return bolsaslogo[route.params.id];
    })

    const route = useRoute();
    const bolsa = ref(null);

    const fetchBolsa = () => {
      axios.get(`/bolsassas/${route.params.id}?idioma=${lang}`).
        then(response => {
          bolsa.value = response.data;
          const updatedBreadcrumb = [
            ...breadcrumb.value,
            { ID: 6, text: response.data.Titulo, href: "#" }
          ];
          breadcrumb.value = updatedBreadcrumb;
        }).
        catch(error => {
          console.log(error);
        })
    }

    fetchBolsa();

    var navigationbar = document.getElementsByClassName("title-bar")[0];
    navigationbar.classList.add("black");
    var offcontent = document.getElementsByClassName("off-canvas-content")[0];
    offcontent.classList.add("padding");

    onBeforeRouteLeave(async (to, from) => {
      var navigationbar = document.getElementsByClassName("title-bar")[0];
      navigationbar.classList.remove("black");
      var offcontent = document.getElementsByClassName("off-canvas-content")[0];
      offcontent.classList.remove("padding");
    });

    return {
      bolsaImage,
      breadcrumb,
      bolsa,
      bolsaslogo
    }
  }
}
</script>

<style lang="scss" scoped>

.extensao_banner h1 {
  text-align: center;
  font-family: Montserrat Bold;
  padding-bottom: 30px;
  padding-top: 120px;
  transform: translate3D(0,-10px,0);
  font-size: 55px;
  color: #4d5354;
}

@media (max-width: 1400px) {
  .extensao_banner h1 {
    font-size: 48px;
  }
}

@media (max-width: 1024px) {
  .extensao_banner h1 {
    font-size: 40px;
  }
}

@media (max-width: 767px) {
  .extensao_banner h1 {
    font-size: 20px;
    padding-bottom: 0;
  }
}



.bcp {
  position: absolute;
  left: 50%;
  transform: translate(-50%, 0);
  z-index: 90;
  padding-top: 15px;
  top: 110px;
}


.bolsawhitewrapper {
  margin-top: 0px;
  padding-bottom: 150px;
  margin-bottom: 0px;
  padding-top: 100px;
  background-color: #f0f0f3;
}

@media (max-width: 767px) {
  .bolsawhitewrapper {
    margin-top: 0;
    padding-top: 20px;
    margin-bottom: 0px;
    padding-bottom: 30px;
  }
}

.bolsawhitewrapper>.columns {
  background: white;
  padding: 70px 93px;
}

@media (max-width: 1024px) {
  .bolsawhitewrapper>.columns {
    padding: 70px 53px;
  }
}

@media (max-width: 767px) {
  .bolsawhitewrapper>.columns {
    padding: 25px 10px;
  }
}

.bolsawhitewrapper .bolsawrapper {
  background: white;
}

.bolsadescricao {
  font-family: "PT Sans";
  font-size: 20px;
  color: #494d52;
  margin-bottom: 40px;
  line-height: 2;
}

.bolsawrapper {
  background: white;
}

h1.bolsadetalhetitulo {
  color: #6eb7ec !important;
  padding-top: 0 !important;
}

.marginbottom {
  margin-bottom: 100px;
}

.bolsawhitewrapper .accordion-title,
.bolsawhitewrapper .accordion-content,
.bolsawhitewrapper .accordion-title a {
  background: white !important;
}

@media (max-width: 767px) {
  .bolsadescricao {
    font-size: 14px;
  }

  .bolsawrapper {
    margin-bottom: 60px;
  }

  .bolsawhitewrapper .bolsawrapper {
    margin-bottom: 20px;
  }
}


.protocolo {
  margin-top: 40px;
  color: #6eb7ec;
  font-family: "Montserrat Semibold";
  font-size: 15px;
  display: block;
}

@media (max-width: 767px) {
  .protocolo {
    font-size: 14px;
  }
}


</style>